import * as types from './mutations-types';

export const mutations = {
  [types.FETCH_USERS_SUCCESS](state, user) {
    state.user = user;
  },
  [types.CHECK_USER_FAILURE](state, data) {
    state.notExistsEmail = data;
  },
  [types.FETCH_USER_METADATA_STARTED](state) {
    state.isUserMetadataLoading = true;
  },
  [types.FETCH_USER_METADATA_SUCCESS](state, metadata) {
    state.isUserMetadataLoading = true;
    state.lastLoggedIn = metadata && metadata.lastLoggedIn;
  },
  [types.FETCH_USER_METADATA_FAILURE](state) {
    state.isUserMetadataLoading = false;
  },
  [types.UPDATE_USER_METADATA_STARTED](state) {
    state.isUserMetadataLoading = true;
  },
  [types.UPDATE_USER_METADATA_SUCCESS](state) {
    state.isUserMetadataLoading = false;
  },
  [types.UPDATE_USER_METADATA_FAILURE](state) {
    state.isUserMetadataLoading = false;
  },
};
